// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lifecycle_track__qu9iF {
  position: relative;
}
.lifecycle_rail__BWNIg {
  position: absolute;
  background: var(--color-border);
  overflow: hidden;
  /* mobile: vertical line through the dots */
  left: 1.125rem;
  top: 0.5rem;
  bottom: 0.5rem;
  width: 2px;
}
.lifecycle_fill__xu4vY {
  position: absolute;
  inset: 0;
  background: var(--color-accent);
  transform-origin: top;
  transform: scaleY(var(--p, 0));
}
.lifecycle_steps__PPvej {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: var(--space-6);
  position: relative;
}
.lifecycle_step__A\\+vCZ {
  position: relative;
  padding-left: 3.5rem;
}
.lifecycle_dot__qWH\\+G {
  position: absolute;
  left: 0;
  top: -0.1rem;
  width: 2.25rem;
  height: 2.25rem;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: var(--color-paper);
  border: 2px solid var(--color-border);
  font-size: var(--text-caption);
  font-weight: 700;
  color: var(--color-text-muted);
  font-variant-numeric: tabular-nums;
  transition: background var(--dur) var(--ease-out),
    border-color var(--dur) var(--ease-out), color var(--dur) var(--ease-out);
}
.lifecycle_step__A\\+vCZ[data-reached="true"] .lifecycle_dot__qWH\\+G {
  background: var(--color-accent);
  border-color: var(--color-accent);
  color: #111;
}
.lifecycle_stepTitle__OD2I5 {
  margin: 0 0 var(--space-2);
  font-size: 1.2rem;
  font-weight: 500;
}
.lifecycle_stepText__ikNXx {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.55;
  color: var(--color-text-muted);
}

@media (min-width: 1200px) {
  .lifecycle_rail__BWNIg {
    left: 1.125rem;
    right: 1.125rem;
    top: 1.05rem;
    bottom: auto;
    width: auto;
    height: 2px;
  }
  .lifecycle_fill__xu4vY {
    transform-origin: left;
    transform: scaleX(var(--p, 0));
  }
  .lifecycle_steps__PPvej {
    grid-template-columns: repeat(7, minmax(0, 1fr));
    gap: var(--space-4);
  }
  .lifecycle_step__A\\+vCZ {
    padding-left: 0;
    padding-top: 3.5rem;
  }
  .lifecycle_dot__qWH\\+G {
    top: 0;
  }
  .lifecycle_stepTitle__OD2I5 {
    font-size: 1.05rem;
  }
  .lifecycle_stepText__ikNXx {
    font-size: 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/HOME_PAGE/SECTIONS/LIFECYCLE/lifecycle.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,2CAA2C;EAC3C,cAAc;EACd,WAAW;EACX,cAAc;EACd,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,8BAA8B;EAC9B,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC;6EAC2E;AAC7E;AACA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,8BAA8B;EAChC;EACA;IACE,gDAAgD;IAChD,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,MAAM;EACR;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".track {\n  position: relative;\n}\n.rail {\n  position: absolute;\n  background: var(--color-border);\n  overflow: hidden;\n  /* mobile: vertical line through the dots */\n  left: 1.125rem;\n  top: 0.5rem;\n  bottom: 0.5rem;\n  width: 2px;\n}\n.fill {\n  position: absolute;\n  inset: 0;\n  background: var(--color-accent);\n  transform-origin: top;\n  transform: scaleY(var(--p, 0));\n}\n.steps {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: var(--space-6);\n  position: relative;\n}\n.step {\n  position: relative;\n  padding-left: 3.5rem;\n}\n.dot {\n  position: absolute;\n  left: 0;\n  top: -0.1rem;\n  width: 2.25rem;\n  height: 2.25rem;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  background: var(--color-paper);\n  border: 2px solid var(--color-border);\n  font-size: var(--text-caption);\n  font-weight: 700;\n  color: var(--color-text-muted);\n  font-variant-numeric: tabular-nums;\n  transition: background var(--dur) var(--ease-out),\n    border-color var(--dur) var(--ease-out), color var(--dur) var(--ease-out);\n}\n.step[data-reached=\"true\"] .dot {\n  background: var(--color-accent);\n  border-color: var(--color-accent);\n  color: #111;\n}\n.stepTitle {\n  margin: 0 0 var(--space-2);\n  font-size: 1.2rem;\n  font-weight: 500;\n}\n.stepText {\n  margin: 0;\n  font-size: 0.95rem;\n  line-height: 1.55;\n  color: var(--color-text-muted);\n}\n\n@media (min-width: 1200px) {\n  .rail {\n    left: 1.125rem;\n    right: 1.125rem;\n    top: 1.05rem;\n    bottom: auto;\n    width: auto;\n    height: 2px;\n  }\n  .fill {\n    transform-origin: left;\n    transform: scaleX(var(--p, 0));\n  }\n  .steps {\n    grid-template-columns: repeat(7, minmax(0, 1fr));\n    gap: var(--space-4);\n  }\n  .step {\n    padding-left: 0;\n    padding-top: 3.5rem;\n  }\n  .dot {\n    top: 0;\n  }\n  .stepTitle {\n    font-size: 1.05rem;\n  }\n  .stepText {\n    font-size: 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"track": `lifecycle_track__qu9iF`,
	"rail": `lifecycle_rail__BWNIg`,
	"fill": `lifecycle_fill__xu4vY`,
	"steps": `lifecycle_steps__PPvej`,
	"step": `lifecycle_step__A+vCZ`,
	"dot": `lifecycle_dot__qWH+G`,
	"stepTitle": `lifecycle_stepTitle__OD2I5`,
	"stepText": `lifecycle_stepText__ikNXx`
};
export default ___CSS_LOADER_EXPORT___;
